// extracted by mini-css-extract-plugin
export default {"cellAlign":"cellAlign---XmAK5","authorityIcon":"authorityIcon---tJicw"};